import { useContext } from 'react';
import { ThemeContext } from './theme-context';
/**
 * Zugriff auf Theme- und Sprach-Zustand. Muss innerhalb von `<ThemeProvider>`
 * verwendet werden, sonst wird ein aussagekraeftiger Fehler geworfen.
 */
export function useTheme() {
    const ctx = useContext(ThemeContext);
    if (!ctx) {
        throw new Error('useTheme() muss innerhalb von <ThemeProvider> verwendet werden.');
    }
    return ctx;
}
